import { useEffect, useState } from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import api from "@/lib/api";
import PublicLayout from "@/components/public/PublicLayout";

export default function Contact() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/public/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  const items = [
    [Phone, "Phone / UAN", `${s.phone || ""} · ${s.uan || ""}`],
    [Mail, "Email", s.email],
    [MapPin, "Address", s.address],
    [Clock, "Business Hours", s.business_hours],
  ];
  return (
    <PublicLayout>
      <div className="mx-auto max-w-4xl px-6 py-14">
        <span className="overline text-primary">Get in touch</span>
        <h1 className="mt-2 font-display text-3xl font-bold tracking-tight lg:text-4xl">Contact Us</h1>
        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {items.map(([Icon, t, v], k) => (
            <div key={k} className="flex items-start gap-3 rounded-xl border border-border bg-card p-5">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-lg bg-accent text-accent-foreground"><Icon className="h-5 w-5" /></span>
              <div><p className="font-display font-semibold">{t}</p><p className="text-sm text-muted-foreground">{v}</p></div>
            </div>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
